import styled from '@emotion/styled';

export const StyledPyramid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 25px;
  grid-row-gap: 25px;
  margin: 20px auto 0 auto;
  z-index: 9;

  [class^='element'] {
    border-radius: 2px;
    > div {
      height: 100%;
    }
  }

  .element-0 {
    position: absolute;
    left: 0;
    top: 67px;
    width: 330px;
    border-right: 1px solid #eee;
    background-color: #fff;
    padding: 15px;
    z-index: 9999;
    height: 100%;
  }

  .element-1 {
    height: 116px;
    width: 116px;
    grid-area: 3 / 1 / 4 / 2;
    background-color: #eae3fe;
    border: 1px solid #beaaf8;
  }

  .element-2 {
    height: 116px;
    width: 116px;
    grid-area: 4 / 1 / 5 / 2;
    background-color: #eae3fe;
    border: 1px solid #beaaf8;
  }

  .element-3 {
    height: 116px;
    width: 116px;
    grid-area: 2 / 2 / 3 / 3;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-4 {
    height: 116px;
    width: 116px;
    grid-area: 3 / 2 / 4 / 3;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-5 {
    height: 116px;
    width: 116px;
    grid-area: 4 / 2 / 5 / 3;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-6 {
    height: 116px;
    width: 116px;
    grid-area: 1 / 3 / 2 / 4;
    background-color: #fff;
    border: 1px solid #beaaf8;
  }

  .element-7 {
    height: 116px;
    width: 116px;
    grid-area: 2 / 3 / 3 / 4;
    background-color: #fff;
    border: 1px solid #beaaf8;
  }

  .element-8 {
    height: 116px;
    width: 116px;
    grid-area: 3 / 3 / 4 / 4;
    background-color: #fff;
    border: 1px solid #beaaf8;
  }

  .element-9 {
    height: 116px;
    width: 116px;
    grid-area: 4 / 3 / 5 / 4;
    background-color: #fff;
    border: 1px solid #beaaf8;
  }

  .element-10 {
    height: 116px;
    width: 116px;
    grid-area: 2 / 4 / 3 / 5;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-11 {
    height: 116px;
    width: 116px;
    grid-area: 3 / 4 / 4 / 5;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-12 {
    height: 116px;
    width: 116px;
    grid-area: 4 / 4 / 5 / 5;
    background-color: #f6f4fc;
    border: 1px solid #beaaf8;
  }

  .element-13 {
    height: 116px;
    width: 116px;
    grid-area: 3 / 5 / 4 / 6;
    background-color: #d5caf7;
    border: 1px solid #d5caf7;
  }

  .element-14 {
    height: 116px;
    width: 116px;
    grid-area: 4 / 5 / 5 / 6;
    background-color: #d5caf7;
    border: 1px solid #d5caf7;
  }
`;

export const StyledBackground = styled.div`
  position: absolute;
  left: 0;
  top: 280px;
  background-image: url('${({ background }: { background: string }) => background}');
  width: 100%;
  height: 580px;
`;

export const StyledArrowLeft = styled.div`
  grid-area: 1/5/3/5;
`;

export const StyledSidebar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 99;
`;

export const StyledElements = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  padding-bottom: 80px;

  > div {
    margin-bottom: 20px;
  }
`;

export const StyledBottom = styled.div`
  background-color: #fff;
  position: relative;
`;

export const StyledMobileBig = styled.div`
  font-family: sans-serif;
  text-align: center;
`;

export const StyledBackgroundMobileBig = styled.div`
  background-image: url('${({ background }: { background: string }) => background}');
  position: absolute;
  left: 0;
  top: 280px;
  width: 100%;
  height: 450px;
`;

export const StyledPyramidMobileBig = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  z-index: 9;

  [class^='div'] {
    height: 80px;
    width: 80px;
    border: 1px solid #beaaf8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .div1 {
    grid-area: 3 / 1 / 4 / 2;
    background-color: #eae3fe;
  }

  .div2 {
    grid-area: 4 / 1 / 5 / 2;
    background-color: #eae3fe;
  }

  .div3 {
    grid-area: 2 / 2 / 3 / 3;
    background-color: #f6f4fc;
  }

  .div4 {
    grid-area: 3 / 2 / 4 / 3;
    background-color: #f6f4fc;
  }

  .div5 {
    grid-area: 4 / 2 / 5 / 3;
    background-color: #f6f4fc;
  }

  .div6 {
    grid-area: 1 / 3 / 2 / 4;
    background-color: #fff;
  }

  .div7 {
    grid-area: 2 / 3 / 3 / 4;
    background-color: #fff;
  }

  .div8 {
    grid-area: 3 / 3 / 4 / 4;
    background-color: #fff;
  }

  .div9 {
    grid-area: 4 / 3 / 5 / 4;
    background-color: #fff;
  }

  .div10 {
    grid-area: 2 / 4 / 3 / 5;
    background-color: #f6f4fc;
  }

  .div11 {
    grid-area: 3 / 4 / 4 / 5;
    background-color: #f6f4fc;
  }

  .div12 {
    grid-area: 4 / 4 / 5 / 5;
    background-color: #f6f4fc;
  }

  .div13 {
    grid-area: 3 / 5 / 4 / 6;
    background-color: #eae3fe;
  }

  .div14 {
    grid-area: 4 / 5 / 5 / 6;
    background-color: #eae3fe;
  }

  .square {
    aspect-ratio: 1 / 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #eee;
    font-size: 12px;
  }
`;

export const StyledResultMobileBig = styled.div`
  background-color: #8a69ea;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
`;
